
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ru"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_45US_46json_ad5d6752",
      load: () => import("#nuxt-i18n/ad5d6752" /* webpackChunkName: "locale_en_45US_46json_ad5d6752" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_45RU_46json_8c92d056",
      load: () => import("#nuxt-i18n/8c92d056" /* webpackChunkName: "locale_ru_45RU_46json_8c92d056" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: true,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      name: "English (US)",
      files: [
        {
          path: "/var/www/mov-dev.m2lab.ru/i18n/locales/en-US.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      iso: "ru-RU",
      name: "Русский (РФ)",
      files: [
        {
          path: "/var/www/mov-dev.m2lab.ru/i18n/locales/ru-RU.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "ru",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: [
    {
      langDir: "/var/www/mov-dev.m2lab.ru/node_modules/nuxt-zod-i18n/dist/runtime/i18n/locales",
      locales: []
    }
  ]
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "English (US)",
    files: [
      {
        path: "/var/www/mov-dev.m2lab.ru/i18n/locales/en-US.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    iso: "ru-RU",
    name: "Русский (РФ)",
    files: [
      {
        path: "/var/www/mov-dev.m2lab.ru/i18n/locales/ru-RU.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/